var _path, _path2, _circle, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 232,
    viewBox: "0 0 320 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.208 153.867C201.953 153.711 218.837 153.547 226.712 153.745C228.635 153.793 230.302 152.244 230.302 150.32V142.417C230.302 139.722 233.397 138.201 235.53 139.848L263.106 161.142C264.788 162.441 264.788 164.98 263.106 166.278L235.53 187.572C233.397 189.219 230.302 187.699 230.302 185.004V173.781C230.302 171.989 228.85 170.537 227.058 170.537H191.269C189.477 170.537 188.024 169.084 188.024 167.292V157.109C188.024 155.337 189.437 153.893 191.208 153.867Z",
    stroke: "#FB7C51",
    strokeWidth: 2.02796
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.857 149.771V100.643C217.857 100.131 217.918 99.6232 217.977 99.1145C218.584 93.9229 215.322 85.2315 197.466 86.8136H144.043C138.206 86.7147 126.889 93.5806 128.313 121.835C129.738 150.09 130.49 196.727 130.688 216.513C130.094 221.262 131.519 230.759 141.966 230.759C152.413 230.759 184.704 230.759 199.544 230.759C205.648 230.561 217.857 227.435 217.857 216.513C217.857 205.591 217.857 184.063 217.857 174.665",
    stroke: "#FB7C51",
    strokeWidth: 2.02796
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.502,
    cy: 159.257,
    r: 5.39223,
    stroke: "#FB7C51",
    strokeWidth: 2.02796
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.685 164.886L144.685 174.571",
    stroke: "#FB7C51",
    strokeWidth: 2.02796
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.6 179.344C121.347 183.188 111.118 180.941 96.217 141.205C77.5912 91.5358 83.7999 203.292 43.8869 158.944C3.97388 114.597 -17.3133 56.0576 21.7128 46.3011C60.7389 36.5445 113.957 19.6922 131.696 7.27477C149.435 -5.14261 255.87 -0.707571 243.452 46.3011C231.035 93.3097 231.035 89.762 272.722 110.162C314.409 130.562 327.713 147.414 312.635 166.927C300.572 182.538 248.478 195.31 223.939 199.745",
    stroke: "#FB7C51",
    strokeDasharray: "6.89 6.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIlls);
export default __webpack_public_path__ + "static/media/logoutIlls.25de6038a2e32753e781b51677b508a6.svg";
export { ForwardRef as ReactComponent };